var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sub_sec"},[_c('NewsListWrap',{attrs:{"newsList":_vm.newsList}}),(_vm.more)?[_c('SubmitButton',{attrs:{"btnObj":{ class: 'more', text: '더보기' }},on:{"btnEvt":_vm.showMore}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }